import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { LandingPage } from '../pages/LandingPage'
import { LoginPage } from '../pages/LoginPage'
import { RegisterPage } from '../pages/RegisterPage'
import { AuthorizePage } from '../pages/AuthorizePage'
import { AccountLayout } from '../components/AccountLayout'
import { InicioSection } from '../pages/account/InicioSection'
import { CertificatesSection } from '../pages/account/CertificatesSection'
import { TeamsSection } from '../pages/account/TeamsSection'
import { SecuritySection } from '../pages/account/SecuritySection'
import { StudentProfileSection } from '../pages/account/StudentProfileSection'
import { PerfilSection } from '../pages/account/PerfilSection'
import { GeneralSection } from '../pages/account/GeneralSection'
import { VersionTag } from '../components/VersionTag'

export function App() {
  return (
    <BrowserRouter>
      <VersionTag />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/authorize" element={<AuthorizePage />} />
        <Route path="/cuenta" element={<AccountLayout />}>
          <Route index element={<InicioSection />} />
          <Route path="certificados" element={<CertificatesSection />} />
          <Route path="perfil" element={<PerfilSection />} />
          <Route path="perfil-estudiante" element={<StudentProfileSection />} />
          <Route path="general" element={<GeneralSection />} />
          <Route path="equipos" element={<TeamsSection />} />
          <Route path="seguridad" element={<SecuritySection />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
